import { useCallback, useContext, useEffect, useState } from "react";
import "./Login.scss";
import { NavLink, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { UserContext } from "../context/UserContext";
import { useDispatch, useSelector } from "react-redux";
import { handleLoginRedux } from "../../redux/actions/userAction";
const Login = (props) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.user.isLoading);
  const account = useSelector((state) => state.user.account);

  const [keyLogin, setValueLogin] = useState("");
  const [password, setPassword] = useState("");
  const defaultObjectCheck = {
    isValidEmail: true,
    isValidPassword: true,
  };
  const [objectCheckInput, setObjectCheckInput] = useState(defaultObjectCheck);
  const history = useHistory();
  const handleCreateNewAccount = () => {
    history.push("/register");
  };

  const handleClickLogin = () => {
    let isValid = validateInputs();
    if (isValid) {
      dispatch(handleLoginRedux(keyLogin, password));
    }
  };
  const validateInputs = () => {
    setObjectCheckInput(defaultObjectCheck);
    if (!toast) {
      toast.error("Email is not empty!");
      setObjectCheckInput({ ...defaultObjectCheck, isValidEmail: false });
      return false;
    }
    var re = /\S+@\S+\.\S+/;
    if (!re.test(keyLogin)) {
      toast.error("Email is invalid!");
      setObjectCheckInput({ ...defaultObjectCheck, isValidEmail: false });
      return false;
    }
    if (!password) {
      toast.error("Password is not empty!");
      setObjectCheckInput({ ...defaultObjectCheck, isValidPassword: false });
      return false;
    }
    return true;
  };
  const handleKeyPress = useCallback((event) => {
    if (event.keyCode === 13 && event.code === "Enter") {
      handleClickLogin();
    }
  });
  useEffect(() => {
    document.addEventListener("keydown", handleKeyPress);
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [handleKeyPress]);
  useEffect(() => {
    if (account && account.auth === true) {
      history.push("/admin");
    }
  }, [account]);

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <div className="auth-brand">
          <div className="auth-brand-mark">M</div>
          <span className="auth-brand-name">MDTeam Console</span>
        </div>
        <p className="auth-subtitle">
          Đăng nhập để quản lý app và gửi push notification.
        </p>

        <div className="mb-3">
          <label className="form-label" htmlFor="login-email">
            Email
          </label>
          <input
            id="login-email"
            className={
              objectCheckInput.isValidEmail
                ? "form-control"
                : "form-control is-invalid"
            }
            type="text"
            placeholder="you@example.com"
            value={keyLogin}
            onChange={(event) => setValueLogin(event.target.value)}
          />
        </div>
        <div className="mb-3">
          <label className="form-label" htmlFor="login-password">
            Mật khẩu
          </label>
          <input
            id="login-password"
            className={
              objectCheckInput.isValidPassword
                ? "form-control"
                : "form-control is-invalid"
            }
            type="password"
            placeholder="••••••••"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </div>
        <button
          className="btn btn-primary w-100 py-2 fw-semibold"
          onClick={() => handleClickLogin()}
        >
          Đăng nhập
        </button>
        <div className="text-center mt-3">
          <a href="/" className="small text-decoration-none">
            Quên mật khẩu?
          </a>
        </div>
        <hr className="my-4" />
        <button
          className="btn btn-outline-secondary w-100"
          onClick={() => handleCreateNewAccount()}
        >
          Tạo tài khoản mới
        </button>
      </div>
    </div>
  );
};

export default Login;
